import React from "react";
import { useNavigate } from "react-router-dom";
import {
  FilterFilled,
  ExportOutlined,
  CloseOutlined,
  DownOutlined
} from "@ant-design/icons";
import { t } from "i18next";
import moment from "moment";
import {
  Row,
  Col,
  Table,
  Breadcrumb,
  Button,
  Input,
  SearchOutlined,
  DatePicker,
  Drawer,
  Form,
  SearchSelectInput,
  Select,
  InputRangeDate,
  Menu,
  Dropdown,
} from "common/elements";
import { Util } from "common/util";

const util = new Util();
export default function withDataTable({
  title = "",
  subTitle = "",
  pathName = "/",
  backLink = "",
  dateFormat = "",
  dateRangeFormat = "",
  defaultPageSize = 20,
  showPagination = false,
  pickerDate = "",
  datePlaceholder = "",
  dateRangePlaceholder = "",
  allowClearPayroll = true,
  rowClassName = "",
  footerButton = false,
  showFilter = false,
  showExport = false,
  showDropdownExport = false,
  menuItems = [],
  showFetchListDate = true,
  showDate = false,
  showDateRange = false,
  onShowInputSearch = true,
  onShowSelect = false,
  showRangeMonthPicker = false,
  showPayrollPeriod = false,
  columns = [],
  tableScrollY = null,
  topFilterItems = [],
  componentWillMount = () => { },
  handleSearch = (e) => { },
  filterFields = () => { },
  buttonOption = () => { },
  getCustomColumns = (response) => [],
  getResponseData = (response) => response,
  getData = () => new Promise((resolve) => resolve(null)),
  getDataSelectSearch = () => { },
}) {
  return () => {
    const [datas, setDatas] = React.useState([]);
    const [customHeadColumns, setCustomHeadColumns] = React.useState([]);
    const [loading, setLoading] = React.useState(true);
    const navigate = useNavigate();
    const params = new URLSearchParams(document.location.search);
    let timer = null;

    const fetchList = () => {
      setLoading(true);
      getData()
        .then((response) => {
          if (response) {
            setCustomHeadColumns(getCustomColumns(response));
            response = getResponseData(response);
            if (response) {
              setDatas(response);
            }
          }
        })
        .catch(error => {
          if (error.response.status === 403) {
            localStorage.removeItem("ACCESS_TOKEN");
            navigate("/signin");
          }
        })
        .finally(() => setLoading(false));
    };

    const onBack = () => {
      navigate(backLink);
    };

    const onSearch = (e) => {
      clearTimeout(timer);
      handleSearch(e);
      timer = setTimeout(() => {
        fetchList();
      }, 1000);
    };

    const onChangePayrollPeriod = (value) => {
      const queryParams = new URLSearchParams(document.location.search);
      queryParams.set("payrollPeriod", value);
      util.pushParamsToURL(pathName, queryParams.toString());
      fetchList();
    };

    const onChangeSelectSearch = (value) => {
      const queryParams = new URLSearchParams(document.location.search);
      if (value && value.key) {
        queryParams.set("employeeId", value.key);
        queryParams.set("employeeName", value.label);
        util.pushParamsToURL(pathName, queryParams.toString());
        fetchList();
      }
      if (value === undefined) {
        queryParams.delete("employeeId");
        queryParams.delete("employeeName");
        util.pushParamsToURL(pathName, queryParams.toString());
        fetchList();
      }
    };

    const onChangeRangeMonthPicker = (value) => {
      let symbol = "";
      let startMonth = "";
      let endMonth = "";
      if (value) {
        startMonth = `${symbol}${moment(value[0]).format("YYYY-MM")}`;
        endMonth = `${symbol}${moment(value[1]).format("YYYY-MM")}`;
        params.set("startMonth", startMonth);
        params.set("endMonth", endMonth);
      } else {
        params.delete("startMonth");
        params.delete("endMonth");
      }
      util.pushParamsToURL(pathName, params.toString());
      fetchList();
    }

    const onTableChange = (newPagination, filters, sorter) => {
      fetchList({
        sortField: sorter.field,
        sortOrder: sorter.order,
        pagination: newPagination,
        ...filters,
      });
    };

    React.useMemo(() => {
      componentWillMount();
    }, []);

    React.useEffect(() => {
      fetchList();
      // eslint-disable-next-line
    }, []);

     const onChangePagination = (page, pageSize) => {
          const params = new URLSearchParams(document.location.search);
          params.set("current", page);
          params.set("size", pageSize);
          Util.getInstance().pushParamsToURL(pathName, params.toString());
          fetchList();
        };

    const pagination = {
          current: params.has("current") ? parseInt(params.get("current")) : 1,
          defaultPageSize,
          pageSizeOptions: ["20", "30", "50", "100"],
          total: datas.pagination?.total,
          showSizeChanger: false,
          locale: { items_per_page: "" },
          onChange: onChangePagination,
        };

    return (
      <>
        <Row style={styles.breadCream}>
          <Col span={24}>
            <Breadcrumb>
              <Breadcrumb.Item
                onClick={() => navigate("/")}
                style={{ cursor: "pointer" }}
              >
                {t("text_dashboard")}
              </Breadcrumb.Item>
              <Breadcrumb.Item onClick={onBack} style={{ cursor: "pointer" }}>
                {title}
              </Breadcrumb.Item>
              <Breadcrumb.Item style={{ color: "#1d8747" }}>
                {subTitle}
              </Breadcrumb.Item>
            </Breadcrumb>
          </Col>
        </Row>
        <Row style={{ padding: 15 }} id="header-report-table">
          <Col span={12}>
            <Title subTitle={subTitle} />
          </Col>
          <Col
            span={12}
            style={{
              textAlign: "right",
              display: "flex",
              justifyContent: "flex-end",
              paddingRight: 5,
            }}
          >
            {onShowSelect && (
              <div id="main-select">
                <SearchSelectInput
                  name="employeeId"
                  placeholder={t("text_search_customer")}
                  fetchOptions={getDataSelectSearch}
                  defaultValue={params.get("employeeName")}
                  onChange={onChangeSelectSearch}
                  style={styles.formInline}
                />
              </div>
            )}

            {onShowInputSearch && (
              <Input
                placeholder={t("text_search_by_employee")}
                defaultValue={params.get("search")}
                prefix={<SearchOutlined />}
                style={styles.generalSearch}
                allowClear={true}
                onChange={onSearch}
              />
            )}

            {
              showPayrollPeriod &&
              <Select
                defaultValue={params.get("payrollPeriod") ? params.get("payrollPeriod") : "first_payment"}
                style={{
                  width: 180,
                  marginLeft: 15
                }}
                options={[
                  {
                    value: 'first_payment',
                    label: 'First Payment',
                  },
                  {
                    value: 'second_payment',
                    label: 'Second Payment',
                  },
                ]}
                onChange={onChangePayrollPeriod}
              />
            }

            {showDate && (
              <DatePickerFilter
                fetchList={fetchList}
                allowClearPayroll={allowClearPayroll}
                pathName={pathName}
                dateFormat={dateFormat}
                datePlaceholder={datePlaceholder}
                pickerDate={pickerDate}
                showFetchListDate={showFetchListDate}
              />
            )}

            {
              showRangeMonthPicker && (
                <DatePicker.RangePicker
                  picker="month"
                  style={{ marginLeft: 8 }}
                  onChange={onChangeRangeMonthPicker}
                  separator={"~"}
                  format={"MM/YYYY"}
                  value={[
                    params.get("startMonth") && moment(params.get("startMonth")),
                    params.get("endMonth") && moment(params.get("endMonth")),
                  ]}
                />
              )
            }

            {showDateRange && (
              <DateRangePicker
                fetchList={fetchList}
                pathName={pathName}
                dateRangeFormat={dateRangeFormat}
                dateRangePlaceholder={dateRangePlaceholder}
                showFetchListDate={showFetchListDate}
              />
            )}

            {React.useMemo(
              () => (
                <Filter
                  enable={showFilter}
                  filterFields={filterFields}
                  fetchList={fetchList}
                  pathName={pathName}
                />
              ),
              // eslint-disable-next-line
              []
            )}
            {React.useMemo(() => (<ExportButton enable={showExport} filtExport={buttonOption} />), [])}
            {React.useMemo(() => (<ExportDropDownButton enable={showDropdownExport} filtExport={buttonOption} pathName={pathName} menuItems={menuItems} footerButton={footerButton} />), [])}
          </Col>
        </Row>

        <div id="report-table">
          <Table
            bordered
            dataSource={datas.pagination ? datas.data: datas}
            pagination={showPagination ? pagination : false}
            rowClassName={rowClassName}
            onChange={onTableChange}
            rowKey={(record) => `${Date.now() + Math.random() * Math.random()} ${Date.now() * Math.random() + Math.random()}`}
            columns={
              customHeadColumns.length > 0
                ? columns.concat(customHeadColumns)
                : columns
            }
            loading={loading}
          />
        </div>
      </>
    );
  };
}

function Filter({ enable, filterFields, fetchList, pathName }) {
  const [visible, setVisible] = React.useState(false);
  const [form] = Form.useForm();
  const params = new URLSearchParams(window.location.search);
  const onShow = () => {
    setVisible(true);
  };

  React.useEffect(() => {
    if (params.get("dates")) {
      const rangeDates = params.get("dates").split(",");
      form.setFieldsValue({
        dates: [moment(rangeDates[0]), moment(rangeDates[1])],
      });
    }
    if (params.get("preset")) {
      form.setFieldsValue({
        taskPreset: parseInt(params.get("preset")),
      });
    }

    if (params.get("teamId")) {
      form.setFieldsValue({
        teamId: parseInt(params.get("teamId")),
      });
    }
    if (params.get("departmentId")) {
      form.setFieldsValue({
        departmentId: parseInt(params.get("departmentId")),
      });
    }
    //eslint-disable-next-line
  }, []);

  const onReset = () => {
    const params = new URLSearchParams(window.location.search);

    if (params.get("dates")) {
      params.delete("dates");
      form.setFieldsValue({
        dates: undefined,
      });
    }

    if (params.get("month")) {
      params.delete("month");
      form.setFieldsValue({
        month: undefined,
      });
    }

    if (params.get("preset")) {
      params.delete("preset");
      form.setFieldsValue({
        taskPreset: 0,
      });
    }

    if (params.get("teamId")) {
      params.delete("teamId");
      form.setFieldsValue({
        teamId: undefined,
      });
    }

    util.pushParamsToURL(pathName, params.toString());

    util.publishEvent("resetFields");
    fetchList();
    setVisible(false);
  };

  const onApply = () => {
    fetchList();
    setVisible(false);
  };

  const onClose = () => {
    setVisible(false);
  };

  return (
    enable && (
      <>
        <Button
          icon={<FilterFilled />}
          onClick={onShow}
          style={{ marginLeft: 10 }}
        >
          {t("text_filter")}
        </Button>
        <Drawer
          title={
            <div style={styles.headerFilter}>
              <Button onClick={onReset}>{t("text_reset")}</Button>
              <div>{t("text_filter")}</div>
              <Button type="primary" onClick={onApply}>
                {t("text_apply")}
              </Button>
            </div>
          }
          placement="right"
          closable={false}
          onClose={onClose}
          visible={visible}
        >
          <Form style={{ margin: "-20px -20px 0 -20px" }} form={form}>
            {filterFields()}
          </Form>
        </Drawer>
      </>
    )
  );
}

const DatePickerFilter = ({
  pathName,
  fetchList,
  dateFormat,
  datePlaceholder,
  pickerDate,
  showFetchListDate,
  allowClearPayroll,
}) => {
  const queryParams = new URLSearchParams(document.location.search);
  const onChangeDate = (value, valueString) => {
    const dateString = valueString.split("/");
    if (value) {
      if (dateString.length === 3) {
        queryParams.set("date", util.formatDateForMYSQL(value));
      } else {
        queryParams.set("date", moment(value).format("YYYY-MM"));
      }
    } else {
      queryParams.delete("date");
    }
    queryParams.set("current", 1);
    util.pushParamsToURL(pathName, queryParams.toString());
    if (showFetchListDate) fetchList();
  };

  return (
    <>
      <Form style={{ marginLeft: "8px" }}>
        <DatePicker
          name="date"
          placeholder={`${datePlaceholder}`}
          format={`${dateFormat}`}
          style={{ marginLeft: "8px", width: "180px" }}
          defaultValue={
            queryParams.get("date") && moment(queryParams.get("date"))
          }
          picker={`${pickerDate}`}
          allowClear={allowClearPayroll}
          onChange={onChangeDate}
        />
      </Form>
    </>
  );
};

const DateRangePicker = ({
  pathName,
  fetchList,
  dateRangeFormat,
  dateRangePlaceholder,
  showFetchListDate,
}) => {
  const params = new URLSearchParams(document.location.search);
  const onChangeDate = (value) => {
    let symbol = "";
    let startDate = "";
    let endDate = "";

    if (value) {
      startDate = `${symbol}${moment(value[0]).format("YYYY-MM-DD")}`;
      endDate = `${symbol}${moment(value[1]).format("YYYY-MM-DD")}`;
      params.set("startDate", startDate);
      params.set("endDate", endDate);
    } else {
      params.delete("startDate");
      params.delete("endDate");
    }
    util.pushParamsToURL(pathName, params.toString());
    if (showFetchListDate) fetchList();
  };
  return (
    <div id="dateRange">
      <InputRangeDate
        name="datesFilter"
        placeholder={dateRangePlaceholder}
        format={dateRangeFormat}
        onChange={onChangeDate}
        defaultValue={[
          params.get("startDate") && moment(params.get("startDate")),
          params.get("endDate") && moment(params.get("endDate")),
        ]}
        style={{
          width: "300px",
          height: "32px",
          margin: "0 5px",
        }}
        separator={"~"}
      />
    </div>
  );
};

function Title({ subTitle }) {
  return <span id="title-table-report">{subTitle}</span>;
}

function ExportDropDownButton({ enable, filtExport, pathName, menuItems, footerButton }) {
  const [visible, setVisible] = React.useState(false);

  const onClose = () => {
    setVisible(false);
  };

  const onShow = (payrollPeriod) => {
    setVisible(true);
    const params = new URLSearchParams(document.location.search);
    params.set("payrollPeriod", payrollPeriod);
    Util.getInstance().pushParamsToURL(pathName, params.toString());
  };

  return (
    enable && (
      <>
        <Dropdown overlay={
          <Menu>
            {
              menuItems.map((menuItem, index) =>
                <Menu.Item
                  key={index}
                  onClick={() => onShow(menuItem.param)}
                >
                  {menuItem.label}
                </Menu.Item>
              )
            }
          </Menu>
        }>
          <Button
            style={{ marginLeft: 10 }}
          >
            {t("text_export")}
            <DownOutlined style={{ fontSize: 14 }} />
          </Button>
        </Dropdown>
        <Drawer
          title={
            <div style={styles.headerFilter}>
              <div>{t("text_export_report")}</div>
              <div>
                <CloseOutlined onClick={onClose} />
              </div>
            </div>
          }
          placement="right"
          closable={false}
          onClose={onClose}
          visible={visible}
          footer={footerButton && <div style={{ visibility: "hidden" }}>ABC</div>}
        >
          {visible ? <ExportExcelFile filtExport={filtExport} /> : null}
        </Drawer>
      </>
    )
  );
}

function ExportButton({ enable, filtExport }) {
  const [visible, setVisible] = React.useState(false);

  const onClose = () => {
    setVisible(false);
  };

  const onShow = () => {
    setVisible(true);
  };

  return (
    enable && (
      <>
        <Button
          icon={<ExportOutlined />}
          onClick={onShow}
          style={{ marginLeft: 10 }}
        >
          {t("text_export")}
        </Button>
        <Drawer
          title={
            <div style={styles.headerFilter}>
              <div>{t("text_export_report")}</div>
              <div>
                <CloseOutlined onClick={onClose} />
              </div>
            </div>
          }
          placement="right"
          closable={false}
          onClose={onClose}
          visible={visible}
        >
          {visible ? <ExportExcelFile filtExport={filtExport} /> : null}
        </Drawer>
      </>
    )
  );
}

const ExportExcelFile = ({ filtExport }) => {
  return filtExport();
}

const styles = {
  formInline: {
    width: 203,
    display: "inline-block",
    textAlign: "left",
    marginRight: 5,
    marginBottom: 0,
    marginTop: 0,
  },
  generalSearch: {
    width: 203,
  },
  headerFilter: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  breadCream: {
    paddingBottom: 15,
    backgroundColor: "#EFF3F6",
  },
};
